import type { HelpFile } from '../../types/help'
import { MyRequestsTestIds } from '../../../testids/MyRequestsTestIds'

export const myRequestsHelp: HelpFile = {
  docPage: '/docs/my-iam/my-requests',
  texts: {
    [MyRequestsTestIds.myRequestsPage]:
      'Zugriffsanträge und Funktionsgruppen-Anträge, die hier gestellt wurden oder diese Identität als Begünstigte betreffen — Genehmigungsstatus verfolgen und offene Anträge zurückziehen.',
    [MyRequestsTestIds.colBeneficiary]: 'Identität, die den Zugriff erhält, wenn der Antrag genehmigt wird.',
    [MyRequestsTestIds.colItems]: 'Anzahl der Zugriffsprofile oder Rollen in diesem Antrag.',
    [MyRequestsTestIds.colJustification]: 'Fachliche Begründung beim Einreichen des Antrags.',
    [MyRequestsTestIds.colFgBeneficiary]: 'Identität, die die Funktionsgruppen-Zuweisung erhält.',
    [MyRequestsTestIds.colFgCreatedAt]: null,
    [MyRequestsTestIds.colFgItems]: 'Anzahl der Funktionsgruppen in diesem Antrag.',
    [MyRequestsTestIds.colFgJustification]: 'Fachliche Begründung für den Funktionsgruppen-Antrag.',
  },
}
